// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__uFuM0","icon":"style_icon__TaR3O","goHome":"style_go-home__vnyqh"};